module.exports = __webpack_public_path__ + "static/img/banner-primary.cd0abf3e.png";